import axios from "axios";
import { Message } from "element-ui";
import { getToken } from "@/utils/auth";
import { url } from "@/utils/url";
import store from "@/store";
// create an axios instance
const service = axios.create({
  baseURL: "/single", // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 10000, // request timeout
});

// request interceptor
service.interceptors.request.use(
  (config) => {
    if (url[config.url]) {
      config.headers["token"] = "";
    } else {
      config.headers["token"] = getToken() || "";
    }
    return config;
  },
  (error) => {
    console.log(error); // for debug
    return Promise.reject(error);
  }
);

// response interceptor
service.interceptors.response.use(
  (response) => {
    const res = response.data;
    // if the custom code is not 20000, it is judged as an error.
    // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
    if (res.code === 200) {
      // debugger;
      return Promise.resolve(res);
    } else if (res.code === 401) {
      // to re-login
      Message.closeAll();
      Message({
        message: "您已退出登录,请重新登录",
        type: "error",
        offset: 300,
      });
      // eslint-disable-next-line no-undef
      store.dispatch("user/resetToken").then(() => {
        location.reload();
      });
      return Promise.reject(res);
    } else {
      if (res.code !== 501) {
        Message.closeAll();
        Message({
          message: res.msg || "系统异常,请稍后重试",
          type: "error",
          offset: 300,
        });
      }
      return Promise.reject(res);
    }
  },
  (error) => {
    if (error.code === 401) {
      // let url = decodeURIComponent(res.urlToRedirectTo);

      const url = location.origin + "/login";

      store.commit("updateToken", "");
      store.commit("updateUserID", "");
      window.location.href = url;

      // if (res.req == 1) {
      //   store.commit("updateToken", "");
      //   store.commit("updateUserID", "");
      //   window.location = url;
      // } else {
      //   service({
      //     url: "/index",
      //     method: "get",
      //     params: {},
      //   });
      // }
      // }

      // Message.closeAll();
      // Message({
      //   message: "您已退出登录,请重新登录",
      //   type: "error",
      //   offset: 300,
      // });
      // // eslint-disable-next-line no-undef
      // store.dispatch("user/resetToken").then(() => {
      //   location.reload();
      // });
      return Promise.reject(error);
    } else {
      console.log("err" + error); // for debug
      Message.closeAll();
      Message({
        message: "系统异常,请稍后重试",
        type: "error",
        offset: 300,
      });
      return Promise.reject(error);
    }
  }
);
export default service;
